import headerCollapse from './headerCollapse';
import initHeaderTrimCount from './headerTrimCount';
import priceSelector from './priceSelector';
import smoothScrollingElements from './smoothScrollingElements';

document.addEventListener('DOMContentLoaded', (): void => {
  headerCollapse();
  initHeaderTrimCount();
  priceSelector();
  smoothScrollingElements();
});
